import * as React from "react";
import { makeStyles, Button, Input, Label, Spinner, Text } from "@fluentui/react-components";

interface CredentialsFormProps {
  onConnect: (clientId: string, clientSecret: string) => void;
  isConnecting: boolean;
}

const useStyles = makeStyles({
  section: {
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    padding: "16px",
    marginBottom: "16px",
  },
  sectionTitle: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    color: "#6b7280",
    marginBottom: "12px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    rowGap: "4px",
    marginBottom: "12px",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "4px",
  },
});

const CredentialsForm: React.FC<CredentialsFormProps> = ({ onConnect, isConnecting }) => {
  const styles = useStyles();
  const [clientId, setClientId] = React.useState("");
  const [clientSecret, setClientSecret] = React.useState("");

  const handleConnect = () => {
    if (clientId && clientSecret) {
      onConnect(clientId, clientSecret);
    }
  };

  return (
    <div className={styles.section}>
      <Text className={styles.sectionTitle} block>
        Credentials
      </Text>
      <div className={styles.fieldGroup}>
        <Label htmlFor="clientId" size="small">
          Client ID
        </Label>
        <Input
          id="clientId"
          value={clientId}
          onChange={(_, data) => setClientId(data.value)}
          placeholder="Enter your Client ID"
        />
      </div>
      <div className={styles.fieldGroup}>
        <Label htmlFor="clientSecret" size="small">
          Client Secret
        </Label>
        <Input
          id="clientSecret"
          type="password"
          value={clientSecret}
          onChange={(_, data) => setClientSecret(data.value)}
          placeholder="Enter your Client Secret"
        />
      </div>
      <div className={styles.buttonRow}>
        <Button appearance="primary" onClick={handleConnect} disabled={isConnecting || !clientId || !clientSecret}>
          {isConnecting ? (
            <>
              <Spinner size="tiny" />
              &nbsp;Connecting...
            </>
          ) : (
            "Connect"
          )}
        </Button>
      </div>
    </div>
  );
};

export default CredentialsForm;
